var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.17,68.46a36.55,36.55,0,1,0-68,18.47h0l.11.13c1.4,2.37,3.15,4,4.93,6.54l21.22,28.1a6.59,6.59,0,0,0,10.53,0L80.76,94.06a79.64,79.64,0,0,0,5.3-7l.08-.1h0A36.31,36.31,0,0,0,91.17,68.46ZM54.62,84.38A16.09,16.09,0,1,1,70.71,68.29,16.08,16.08,0,0,1,54.62,84.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.36,290.12a16.11,16.11,0,1,0-30,8.14h0l0,.06c.62,1,1.4,1.79,2.18,2.88l9.35,12.39a2.91,2.91,0,0,0,4.65,0l9.19-12.18a34.54,34.54,0,0,0,2.34-3.1l0-.05h0A15.94,15.94,0,0,0,485.36,290.12Zm-16.11,7a7.09,7.09,0,1,1,7.09-7.09A7.1,7.1,0,0,1,469.25,297.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.29,
    cy: 388.67,
    r: 40.34,
    transform: "translate(-157.3 397.59) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.29,422.25a33.58,33.58,0,1,1,33.57-33.58A33.61,33.61,0,0,1,401.29,422.25Zm0-61.41a27.83,27.83,0,1,0,27.83,27.83A27.86,27.86,0,0,0,401.29,360.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.06,400.15a12.37,12.37,0,1,1,12.37-12.36A12.37,12.37,0,0,1,401.06,400.15Zm0-19a6.62,6.62,0,1,0,6.62,6.62A6.63,6.63,0,0,0,401.06,381.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.06 387.79 385.43 387.79 388.16 392.61 351.37 409.47 352.61 411.54 389.52 394.87 392.05 399.66 401.06 387.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.37,409.47l-.39-.38a7.46,7.46,0,0,0-7.31-1.82L329,411.54l8.17,3.59-3.28,8.73L347.66,419a7.48,7.48,0,0,0,4.95-7.41h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.35,417.93l.3-.1.87-.25,3.34-1,12.51-3.51-.12.21c-.64-2.15-1.36-4.55-2.12-7.13l0-.11.1-.09a40.06,40.06,0,0,0,8.72-10.26,28.09,28.09,0,0,0,2.92-7,20.38,20.38,0,0,0,.47-8,25.2,25.2,0,0,0-8.22-15,30.27,30.27,0,0,0-17-7.33,25,25,0,0,0-13.67,2.74,27.29,27.29,0,0,0-10.19,8.57,24.69,24.69,0,0,0-4.38,11.64c-.06,1-.21,2-.19,3s.05,2,.08,2.92a30.08,30.08,0,0,0,1,5.55,26,26,0,0,0,2,4.92,24.11,24.11,0,0,0,2.88,4.09,27.18,27.18,0,0,0,7,5.62,35.94,35.94,0,0,0,12.4,4.28l.07,0v.06l1,4.54c.1.5.18.89.23,1.17s.08.4.08.41a1.57,1.57,0,0,1-.1-.36l-.28-1.14-1.08-4.58.09.08a35.49,35.49,0,0,1-12.55-4.19,27.31,27.31,0,0,1-7.1-5.65,24.53,24.53,0,0,1-3-4.15,26.32,26.32,0,0,1-2.1-5,31.85,31.85,0,0,1-1-5.63l-.09-3c0-1,.13-2,.19-3a25.05,25.05,0,0,1,4.44-11.88,27.82,27.82,0,0,1,10.37-8.76,25.48,25.48,0,0,1,14-2.79,30.69,30.69,0,0,1,17.33,7.47,25.12,25.12,0,0,1,5.61,7.11,15.93,15.93,0,0,1,1,2,14.49,14.49,0,0,1,.78,2c.21.7.44,1.38.63,2.07s.25,1.41.38,2.11a20.94,20.94,0,0,1-.51,8.19,28.35,28.35,0,0,1-3,7.1,40.48,40.48,0,0,1-8.87,10.33l.07-.2,2.07,7.13.05.16-.16.05-12.65,3.36-3.33.87-.84.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,417.94a74.89,74.89,0,0,1-8.69,2.67,75.08,75.08,0,0,1-8.84,2.13,78.63,78.63,0,0,1,8.69-2.66A76.46,76.46,0,0,1,192,417.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.09,426.12a7.13,7.13,0,0,1-3,1.22,7.24,7.24,0,0,1-3.23.28,15.5,15.5,0,0,1,3.1-.82A16.19,16.19,0,0,1,188.09,426.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,417a1.08,1.08,0,0,1-.1-.28c-.06-.22-.13-.5-.23-.85q-.3-1.19-.84-3.27c-.72-2.89-1.74-7-3-12.07-.63-2.55-1.31-5.34-2-8.33a5.55,5.55,0,0,0-.87-2.06,1.47,1.47,0,0,0-1.83-.61,2.13,2.13,0,0,0-.94,1.91,3.28,3.28,0,0,0,.89,2.15,5.26,5.26,0,0,0,4.63,1.53,5.34,5.34,0,0,0,4.06-3.07,8.06,8.06,0,0,0,.58-5.42,4.83,4.83,0,0,0-1.25-2.45,2,2,0,0,0-2.39-.33,2,2,0,0,0-.45,2.39,5.41,5.41,0,0,0,1.86,2,10,10,0,0,0,5.12,2.11,5.64,5.64,0,0,0,2.62-.39,5.44,5.44,0,0,0,2-1.59,4.19,4.19,0,0,0,.92-2.32,3,3,0,0,0-.76-2.25,2,2,0,0,0-2-.7,2.49,2.49,0,0,0-1.52,1.58c-.49,1.47-.06,3.11.12,4.62.48,3,1,5.86,1.53,8.43,1,5.12,1.87,9.27,2.46,12.18.28,1.41.51,2.52.67,3.31.06.36.12.64.16.87a1.53,1.53,0,0,1,0,.3,1.32,1.32,0,0,1-.09-.29c-.06-.22-.13-.5-.22-.85-.19-.79-.44-1.89-.77-3.29-.65-2.86-1.58-7-2.63-12.15-.52-2.57-1.09-5.39-1.6-8.44-.11-.77-.24-1.54-.32-2.35a5.79,5.79,0,0,1,.2-2.5,3,3,0,0,1,1.83-1.89,2.53,2.53,0,0,1,2.57.83,3.55,3.55,0,0,1,.89,2.61,4.66,4.66,0,0,1-1,2.62,5.92,5.92,0,0,1-2.25,1.76,6.26,6.26,0,0,1-2.87.44,10.63,10.63,0,0,1-5.4-2.21,5.76,5.76,0,0,1-2-2.27,2.3,2.3,0,0,1,3.72-2.67,5.44,5.44,0,0,1,1.4,2.72,8.6,8.6,0,0,1-.63,5.79,5.92,5.92,0,0,1-4.46,3.35,5.74,5.74,0,0,1-5.08-1.72,3.73,3.73,0,0,1-1-2.49,2.56,2.56,0,0,1,1.22-2.33,1.79,1.79,0,0,1,1.38-.07,2.28,2.28,0,0,1,1,.82,6.45,6.45,0,0,1,.95,2.24c.71,3,1.37,5.8,2,8.36L176,412.5c.31,1.4.56,2.5.74,3.3.07.35.13.63.18.86A.92.92,0,0,1,176.92,417Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.31,421.68a48.44,48.44,0,0,1-7,2.21,51.21,51.21,0,0,1-7.18,1.68,48.44,48.44,0,0,1,7-2.21A51.56,51.56,0,0,1,191.31,421.68Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.14,467.86c0,.14-95.43.26-213.13.26S36.86,468,36.86,467.86s95.41-.26,213.15-.26S463.14,467.71,463.14,467.86Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.68,
    y: 65.6,
    width: 390.85,
    height: 25.04,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.62,
    y: 113.64,
    width: 390.85,
    height: 219.2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.68 90.45 108.35 90.45 113.66 74.97 200.66 74.97 205.97 90.45 445.53 90.45 445.53 114.17 54.68 114.17 54.68 90.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.58,75.59a2.94,2.94,0,1,1-2.94-2.94A2.93,2.93,0,0,1,67.58,75.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.67,75.59a2.94,2.94,0,1,1-2.94-2.94A2.93,2.93,0,0,1,76.67,75.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.76,75.59a2.94,2.94,0,1,1-2.94-2.94A2.93,2.93,0,0,1,85.76,75.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.33,109.45H134.18a7.44,7.44,0,0,1-7.44-7.44h0a7.44,7.44,0,0,1,7.44-7.44H402.33a7.44,7.44,0,0,1,7.44,7.44h0A7.44,7.44,0,0,1,402.33,109.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,103v2.52h-1.27V103.2c0-.71-.33-1-.89-1s-1.06.38-1.06,1.18v2.18h-1.27V99.46h1.27v2.12a2,2,0,0,1,1.4-.52A1.72,1.72,0,0,1,140.6,103Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.58,105.3a1.78,1.78,0,0,1-1,.28,1.45,1.45,0,0,1-1.64-1.58v-1.8h-.68v-1h.68v-1.07h1.27v1.07h1.09v1h-1.09V104a.51.51,0,0,0,.55.58.82.82,0,0,0,.51-.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,105.3a1.82,1.82,0,0,1-1,.28,1.45,1.45,0,0,1-1.64-1.58v-1.8h-.68v-1h.68v-1.07h1.27v1.07h1.1v1h-1.1V104a.52.52,0,0,0,.55.58.85.85,0,0,0,.52-.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.54,103.32a2.13,2.13,0,0,1-2.19,2.26,1.71,1.71,0,0,1-1.32-.53v2h-1.27v-6H150v.51a1.73,1.73,0,0,1,1.38-.57A2.13,2.13,0,0,1,153.54,103.32Zm-1.29,0a1.12,1.12,0,1,0-1.12,1.22A1.11,1.11,0,0,0,152.25,103.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.08,101.85a.8.8,0,0,1,1.59,0,.8.8,0,1,1-1.59,0Zm0,2.93a.8.8,0,0,1,1.59,0,.8.8,0,1,1-1.59,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,98.64h1.14l-2.7,7.69h-1.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.41,98.64h1.13l-2.69,7.69h-1.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,153.06H168.46a13.19,13.19,0,0,1-13.19-13.19h0a13.2,13.2,0,0,1,13.19-13.19H402.09a13.2,13.2,0,0,1,13.19,13.19h0A13.19,13.19,0,0,1,402.09,153.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,153.06a13.89,13.89,0,0,0,5.4-1.22,13.31,13.31,0,0,0,7.1-8,13.35,13.35,0,0,0,.54-4.83,13.11,13.11,0,0,0-1.48-5.22,13.25,13.25,0,0,0-3.93-4.48,13,13,0,0,0-6.05-2.36,30.74,30.74,0,0,0-3.49-.1h-3.64l-33.59,0-194.47.07a13,13,0,0,0-6.63,1.84,12.93,12.93,0,0,0,.58,22.53,13.41,13.41,0,0,0,6.49,1.5H234.1l87.43.06,59,.08,16,0,4.17,0c.94,0,1.42,0,1.42,0l-1.42,0-4.17,0-16,0-59,.09-87.43.05-51.64,0H168.92a13.77,13.77,0,0,1-6.73-1.56,13.45,13.45,0,0,1,6.29-25.34L363,126.5l33.59,0h3.64a31.79,31.79,0,0,1,3.53.11,13.23,13.23,0,0,1,6.15,2.43,13.19,13.19,0,0,1,5.48,9.88,13.68,13.68,0,0,1-.58,4.9,13.43,13.43,0,0,1-2,3.85,13.26,13.26,0,0,1-5.25,4.23,13.6,13.6,0,0,1-4,1.07C402.57,153.06,402.09,153.06,402.09,153.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.82,142.68l.49-1.1a3.77,3.77,0,0,0,2.1.66c.87,0,1.22-.29,1.22-.68,0-1.19-3.69-.37-3.69-2.73,0-1.08.87-2,2.68-2a4.28,4.28,0,0,1,2.2.56l-.45,1.12a3.55,3.55,0,0,0-1.76-.5c-.87,0-1.21.33-1.21.73,0,1.17,3.69.36,3.69,2.69,0,1.06-.88,2-2.69,2A4.46,4.46,0,0,1,173.82,142.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.75,141.27h-3.69a1.31,1.31,0,0,0,1.4,1,1.66,1.66,0,0,0,1.22-.48l.75.82a2.84,2.84,0,0,1-4.79-1.72,2.48,2.48,0,0,1,2.6-2.51,2.42,2.42,0,0,1,2.54,2.53C184.78,141,184.76,141.15,184.75,141.27Zm-3.71-.83h2.4a1.22,1.22,0,0,0-2.4,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.9,140.52v2.79h-1.32v-.61a1.61,1.61,0,0,1-1.49.68c-1.14,0-1.82-.64-1.82-1.48s.61-1.46,2.09-1.46h1.13c0-.6-.37-1-1.13-1a2.34,2.34,0,0,0-1.4.45l-.51-1a3.76,3.76,0,0,1,2.1-.59C189,138.36,189.9,139.05,189.9,140.52Zm-1.41,1.25v-.5h-1c-.66,0-.87.24-.87.57s.3.59.79.59A1.05,1.05,0,0,0,188.49,141.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.21,138.36v1.3l-.32,0A1.2,1.2,0,0,0,192.6,141v2.31h-1.42v-4.88h1.35v.64A2,2,0,0,1,194.21,138.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.65,140.87a2.52,2.52,0,0,1,2.72-2.51,2.23,2.23,0,0,1,2.18,1.24l-1.1.59a1.21,1.21,0,0,0-1.09-.67,1.35,1.35,0,0,0,0,2.7,1.19,1.19,0,0,0,1.09-.67l1.1.6a2.25,2.25,0,0,1-2.18,1.23A2.52,2.52,0,0,1,194.65,140.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.32,140.52v2.79H203.9v-2.58c0-.79-.36-1.15-1-1.15s-1.17.42-1.17,1.32v2.41h-1.42v-6.73h1.42v2.36a2.14,2.14,0,0,1,1.55-.58A1.91,1.91,0,0,1,205.32,140.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.82,142.49a.88.88,0,0,1,1.76,0,.88.88,0,1,1-1.76,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.2,142.49a.88.88,0,1,1,.88.89A.87.87,0,0,1,211.2,142.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.57,142.49a.88.88,0,0,1,1.76,0,.88.88,0,1,1-1.76,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.07,176c0,.15-9.38.26-20.94.26s-20.94-.11-20.94-.26,9.37-.26,20.94-.26S128.07,175.88,128.07,176Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.19,
    y: 187.99,
    width: 43.52,
    height: 43.52,
    style: {
      fill: "#FF7200"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M394.15,198.25c0,.14-54,.26-120.64.26s-120.65-.12-120.65-.26,54-.26,120.65-.26S394.15,198.1,394.15,198.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.86,214.63c0,.15-14.24.26-31.79.26s-31.8-.11-31.8-.26,14.23-.26,31.8-.26S218.86,214.49,218.86,214.63Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.59,229.83c0,.14-44.85.26-100.16.26s-100.16-.12-100.16-.26,44.84-.27,100.16-.27S355.59,229.68,355.59,229.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.07,254c0,.14-9.38.26-20.94.26s-20.94-.12-20.94-.26,9.37-.26,20.94-.26S128.07,253.83,128.07,254Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.19,
    y: 265.94,
    width: 43.52,
    height: 43.52,
    style: {
      fill: "#FF7200"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M408.49,276.19c0,.15-57.23.26-127.81.26s-127.82-.11-127.82-.26,57.22-.26,127.82-.26S408.49,276.05,408.49,276.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.86,292.58c0,.14-14.24.26-31.79.26s-31.8-.12-31.8-.26,14.23-.26,31.8-.26S218.86,292.44,218.86,292.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M390.47,307.77c0,.15-52.65.26-117.59.26s-117.61-.11-117.61-.26,52.65-.26,117.61-.26S390.47,307.63,390.47,307.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.53,333.37c0-1.72-.08-104.8-.21-267.77l.21.21-390.82,0h0l.26-.26c0,95.58,0,186.39,0,267.77l-.24-.24,390.85.24-390.85.23h-.24v-.23c0-81.38,0-172.19,0-267.77v-.26h.29l390.82,0h.21v.21C445.62,228.57,445.53,331.65,445.53,333.37Z",
    style: {
      fill: "#263238"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1,85c0,.15-13.8.26-30.82.26s-30.82-.11-30.82-.26,13.8-.26,30.82-.26S190.1,84.86,190.1,85Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.76,
    y: 134.22,
    width: 54.74,
    height: 16.49,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.43,177.41c0,.15-17,.26-38,.26s-38-.11-38-.26,17-.26,38-.26S231.43,177.27,231.43,177.41Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.43,254c0,.14-17,.26-38,.26s-38-.12-38-.26,17-.26,38-.26S231.43,253.83,231.43,254Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.06,144.26a6.36,6.36,0,1,1,6.35-6.35A6.36,6.36,0,0,1,397.06,144.26Zm0-11.71a5.36,5.36,0,1,0,5.35,5.36A5.36,5.36,0,0,0,397.06,132.55Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.87,147.08a.51.51,0,0,1-.36-.15l-4.14-4.11a.5.5,0,0,1,.71-.71l4.14,4.11a.51.51,0,0,1-.35.86Z",
    style: {
      fill: "#FF7200"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M299.88,213.51c0,.14-16.37.26-36.57.26s-36.58-.12-36.58-.26,16.38-.26,36.58-.26S299.88,213.36,299.88,213.51Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.15,212.38c0,.15-8.57.26-19.13.26s-19.14-.11-19.14-.26,8.57-.26,19.14-.26S347.15,212.24,347.15,212.38Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299.53,292.58c0,.14-16.37.26-36.57.26s-36.57-.12-36.57-.26,16.37-.26,36.57-.26S299.53,292.44,299.53,292.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270,448.09v20.76l41.88-.2c-.3-4.21-23.29-12.61-23.29-12.61l.46-8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.79,454.16a1.8,1.8,0,0,0-1.14,2.07,1.63,1.63,0,0,0,1.93,1.23,1.92,1.92,0,0,0,1.2-2.21,1.66,1.66,0,0,0-2.14-1",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270,468.85v-3.31l40,.47s2.08,1.25,1.89,2.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.61,456.44c0,.22-1,.33-2,1s-1.51,1.62-1.7,1.54.1-1.34,1.31-2.17S288.65,456.24,288.61,456.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.1,458.36c0,.21-.83.59-1.51,1.51s-.86,1.89-1.06,1.88-.35-1.22.51-2.35S294.09,458.16,294.1,458.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.57,463.65c-.19.05-.49-1,0-2.21s1.45-1.67,1.54-1.49-.49.82-.89,1.8S296.77,463.63,296.57,463.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,450.53c-.08.2-1-.08-2.17,0s-2,.5-2.14.31.74-1,2.09-1.06S288.3,450.36,288.2,450.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.44,457.37a3.26,3.26,0,0,0,.09-1.27,7,7,0,0,0-1.11-3.27,6.51,6.51,0,0,0-1.64-1.73,1.41,1.41,0,0,0-1.41-.25,1.62,1.62,0,0,0-.83,1.37,5.49,5.49,0,0,0,3.68,4.86,5.26,5.26,0,0,0,5.66-1.68,4,4,0,0,0,.75-1.28,1.38,1.38,0,0,0,0-.83,1,1,0,0,0-.57-.6,1.73,1.73,0,0,0-1.3.13,7.59,7.59,0,0,0-1,.55,8.87,8.87,0,0,0-2.39,2.37,3.38,3.38,0,0,0-.58,1.11,12.37,12.37,0,0,1,3.19-3.1c.56-.32,1.3-.78,1.89-.57.26.1.36.41.24.77a3.38,3.38,0,0,1-.66,1.06,4.75,4.75,0,0,1-5.07,1.47,5,5,0,0,1-3.31-4.22,1,1,0,0,1,.49-.9,1,1,0,0,1,.94.18,6.16,6.16,0,0,1,1.55,1.55,7.29,7.29,0,0,1,1.23,3C288.41,456.92,288.39,457.37,288.44,457.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.71 451.09 255.42 456.44 254.95 468.49 239.25 468.87 238.69 456.44 240.47 449.05 254.71 451.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19,467.58c-.1,0,.13-3.68.5-8.23s.76-8.25.85-8.26-.13,3.69-.5,8.24S247.28,467.58,247.19,467.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.01 466.48 239.15 466.67 239.15 468.87 255.02 468.86 255.01 466.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.19,459.55s.11-.25.4-.63a10.33,10.33,0,0,1,1.4-1.5,10.61,10.61,0,0,1,2.53-1.7,8.36,8.36,0,0,1,9.79,1.81,7.35,7.35,0,0,1,1.15,1.71,2,2,0,0,1,.25.71,17.27,17.27,0,0,0-1.64-2.19,8.41,8.41,0,0,0-5.89-2.42,9.6,9.6,0,0,0-6,2.34C239.89,458.75,239.25,459.61,239.19,459.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.12,114.74,247,169l23.29,1.11.68-13.2s8.27,1.64,10.4-6c1.37-4.91,1-42.84,1-42.84Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,111.88c-3.67,1.05-4.47,7-4.47,7l-5.75,12.71c-2.93-2.29-6.87-2.16-7.61,3-.54,3.72,4.09,4.47,4.09,4.47-2.7,4.59-4.52,8.3-8.45,12.66C259,156.47,256.6,156.94,252,157h-5.08s-2.49-8.07-7.09-28.24c-5.1-22.38,21.36-19.5,26.27-25.21C274.09,94.26,297,108.57,285.41,111.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.87,107a5.08,5.08,0,0,0-5.07-4.23,3.15,3.15,0,0,0-.66-4,5.15,5.15,0,0,0-4.19-1,15.38,15.38,0,0,0-4.18,1.5,7.09,7.09,0,0,0-2.7-3.57,8.15,8.15,0,0,0-4.49-1.11c-7.15,0-10.91,4.89-14.75,9.88a6,6,0,0,1-2.32,2.2,6.22,6.22,0,0,1-2.15.24,15.54,15.54,0,0,0-13.22,8.22c-2.5,4.83-4.37,16,2.11,23l3.9,8.71,37.33-29.58c.27.14,2.61,1.28,4.41.34,4.47-2.36,2.59-6.28,2.59-6.28C288.84,111.07,292.25,109.4,291.87,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.32,136.11a8.12,8.12,0,0,1-.13,4.12,8,8,0,0,1-1.65,3.78c-.16-.08.59-1.74,1.07-3.91S257.15,136.11,257.32,136.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.14,133.44a10.07,10.07,0,0,1-.22,4,9.85,9.85,0,0,1-1.23,3.78,21.71,21.71,0,0,1,.65-3.89A21,21,0,0,1,260.14,133.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.2,124.48c.06.08-.6.56-1.44,1.54a15.23,15.23,0,0,0-2.51,4.34,37.24,37.24,0,0,0-1.39,4.88,7.44,7.44,0,0,1-.58,2,7.73,7.73,0,0,1,.17-2.13,24.12,24.12,0,0,1,1.25-5,12.76,12.76,0,0,1,2.76-4.4A4.54,4.54,0,0,1,268.2,124.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.46,118.39c.07,0,.31.52.46,1.46a9.74,9.74,0,0,1-.21,3.71,9.31,9.31,0,0,1-1.57,3.36c-.57.77-1,1.14-1.09,1.09s1.43-1.87,2.09-4.59S271.28,118.41,271.46,118.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,131.94c-.08.15-.79-.1-1.59-.55s-1.39-.92-1.31-1.07.79.11,1.59.56S243.75,131.8,243.67,131.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.92,126.15a3.3,3.3,0,0,1-.66,2.36c-.72,1.19-1.69,1.81-1.79,1.69s.63-.9,1.28-2S254.75,126.11,254.92,126.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.38,124.29a4.63,4.63,0,0,1-1,2.82c-.93,1.42-2.1,2.18-2.19,2s.83-1,1.7-2.37A24.67,24.67,0,0,1,258.38,124.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.58,101.55s-.44-.33-1.28-.81a8.59,8.59,0,0,0-3.9-1,10.46,10.46,0,0,0-5.73,1.53,14.23,14.23,0,0,0-4.87,5.44,23.86,23.86,0,0,0-2,5.09l-.1.34-.31-.17a11.69,11.69,0,0,0-5.19-1.33,12.43,12.43,0,0,0-4.23.64,17.87,17.87,0,0,0-3.46,1.73,3.51,3.51,0,0,1,.78-.69,10.54,10.54,0,0,1,2.56-1.37,12.07,12.07,0,0,1,4.35-.79,11.91,11.91,0,0,1,5.46,1.31l-.41.18a24.12,24.12,0,0,1,2-5.22,14.42,14.42,0,0,1,5.11-5.62,10.67,10.67,0,0,1,6-1.49,8.28,8.28,0,0,1,4,1.23,5.23,5.23,0,0,1,.89.71C275.5,101.44,275.59,101.54,275.58,101.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.83,104.51c-.05,0,.64-.18,1.33.6a2.29,2.29,0,0,1,.54,1.7,2.65,2.65,0,0,1-1.36,1.94,3.86,3.86,0,0,1-2.83.39,8.29,8.29,0,0,1-2.91-1.42,27.65,27.65,0,0,0-2.86-2,11.62,11.62,0,0,0-3.44-1.21,14.37,14.37,0,0,0-7,.48,19.2,19.2,0,0,0-5.19,2.64c-2.72,1.95-4.06,3.59-4.15,3.5a7.08,7.08,0,0,1,.93-1.15,22,22,0,0,1,3-2.69,18.72,18.72,0,0,1,5.27-2.82,14.62,14.62,0,0,1,7.3-.54,12.11,12.11,0,0,1,3.61,1.28,27.07,27.07,0,0,1,2.89,2,7.83,7.83,0,0,0,2.71,1.38,3.46,3.46,0,0,0,2.52-.27,2.34,2.34,0,0,0,1.23-1.62,2.07,2.07,0,0,0-.39-1.51A2,2,0,0,0,287.83,104.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.33,146.16c-.88-.78-12.74,4.19-12.74,4.19s-8.85,7-12.49,11.05l-2.25,1.87-33.66,26.17-41.4-17.22-9,23.09s46.48,18.51,53.56,15.34c7.69-3.44,36.34-33.43,36.41-33.53h0l4.14-4s2.19,0,3.85-.14,6.52-3.33,6.52-3.33a9.44,9.44,0,0,0,.94-2.83,1.81,1.81,0,0,0-.9-2.05,6.46,6.46,0,0,0,.08-2.34c-.19-1.32-2-2.85-2-2.85a4.17,4.17,0,0,0,1.11-2.09c.4-1.53-1.57-3-1.57-3s6.89-4.68,8.56-5.51S397.21,146.94,396.33,146.16Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.88,382.69c.14-1.52.21-2.69.21-3.42l4.68-74.63s-3.93-21.8-5.79-27.58l-16.71-6.47L260,279.26c-.14-1.79-.23-2.9-.23-2.9L227,287.7s-.85,22.37,0,29.18c.28,2.19,1.13,7.84,2.17,14.5h0s1.06,14.47,1.28,15.28c.79,2.95,1,10.18,1,17.42,0,9.2.5,20.15,1.08,25.35s.85,62.44.85,62.44h24.2l3.11-91.16c.52-9.77,1.3-24.71,1.8-35.52l5.68,33.66c0,1.23,3.46,20.48,3.46,20.48a182.4,182.4,0,0,0-1.48,18.26c-.4,17-2.39,54.28-2.39,54.28h23.68s7.12-53.88,8.5-69.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,300.17a9.62,9.62,0,0,1-2.19-1.17,29.92,29.92,0,0,1-4.68-3.71,30.5,30.5,0,0,1-3.86-4.55,8.63,8.63,0,0,1-1.23-2.15,18.65,18.65,0,0,1,1.52,1.93,42.35,42.35,0,0,0,3.93,4.41A41.23,41.23,0,0,0,302,298.7,17.34,17.34,0,0,1,304,300.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,313.73a2.89,2.89,0,0,1-.46-.74,22.2,22.2,0,0,1-1-2.16,35.66,35.66,0,0,1-2.21-7.55,36.16,36.16,0,0,1-.48-7.85c.06-1,.14-1.81.23-2.37a2.8,2.8,0,0,1,.19-.86c.08,0,0,1.25-.05,3.24a42.6,42.6,0,0,0,.62,7.75,43.59,43.59,0,0,0,2,7.51C261.27,312.57,261.79,313.69,261.72,313.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.24,341.83a6.49,6.49,0,0,1-.31-1.3q-.26-1.42-.66-3.57c-.52-3.13-1.22-7.25-2-11.81-1.34-8.37-2.25-14.07-2.67-16.72a24.34,24.34,0,0,1,1.14,4.83c.58,3,1.3,7.19,2.06,11.8s1.39,8.81,1.83,11.84c.19,1.44.36,2.64.49,3.6A6,6,0,0,1,265.24,341.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.13,217.35s-3.19,22.49-3.79,30.37c-.36,4.75,4.46,11,8.14,11.51s16.08,1.2,16.08,1.2l1-14.11-.32-2.81-3.85-.72,1.16-22.38Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,221.17a5.09,5.09,0,0,1,.15,1.22c.06.79.1,1.93.13,3.35.07,2.82,0,6.73-.24,11s-.59,8.2-.86,11c-.15,1.4-.27,2.54-.37,3.32a5.26,5.26,0,0,1-.21,1.21,5.55,5.55,0,0,1,0-1.23c.05-.9.12-2,.2-3.34.19-2.93.43-6.76.7-11s.37-8.18.4-11c0-1.32,0-2.44,0-3.34A5.71,5.71,0,0,1,226.07,221.17Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M227.29,288.11c6.3,2.34,13.2,2.53,19.89,1.95s13.31-1.93,20-2.56a95.78,95.78,0,0,1,30.29,2,5.37,5.37,0,0,0,2.14.2,1.79,1.79,0,0,0,1.51-1.34c.18-1.12-1.05-1.9-2.09-2.33a89.35,89.35,0,0,0-71.93,1.6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.75,182.44l-35.52-17.68a115.86,115.86,0,0,0-16.88-.74H247.84s-28.48,8.4-33.19,16.15l-12.21,36.6,24.14,3.64h0l3,26.3s-3,30.45-3,34.87a33.25,33.25,0,0,0,.37,6.12s48.3-7.34,60.19-3.47,15.1,3.47,15.1,3.47-1-12.64-1.87-20L297.63,231l-2-28,22.35,6.84Z",
    style: {
      fill: "#FF7200"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.36,220.7c-.09,0-.33-1.51-.86-3.95a67.07,67.07,0,0,0-2.8-9.33,74.76,74.76,0,0,0-4.14-8.92l-1.46-2.62a4.23,4.23,0,0,1-.49-1,4.73,4.73,0,0,1,.68.89c.41.59,1,1.46,1.61,2.56a58.72,58.72,0,0,1,4.32,8.91,54.25,54.25,0,0,1,2.66,9.44c.22,1.23.36,2.23.43,2.93A4.42,4.42,0,0,1,226.36,220.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.91,231.09a1.71,1.71,0,0,1-.13.49l-.45,1.35c-.2.59-.45,1.3-.78,2.12s-.68,1.76-1.14,2.76c-.87,2-2,4.42-3.42,7s-3.1,5.32-5,8.1-4,5.29-5.89,7.51-3.78,4.09-5.4,5.61c-.79.78-1.56,1.43-2.21,2s-1.24,1.08-1.72,1.47l-1.12.88a2.38,2.38,0,0,1-.41.29s.11-.14.35-.37l1.05-1c.46-.4,1-.91,1.66-1.52s1.38-1.27,2.15-2.06c1.58-1.54,3.38-3.46,5.29-5.66s3.89-4.74,5.83-7.49,3.6-5.5,5-8,2.59-4.9,3.5-6.91c.48-1,.85-1.93,1.2-2.73s.64-1.5.87-2.08.39-1,.54-1.32A2,2,0,0,1,271.91,231.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.32,167.18a11.42,11.42,0,0,0-1.87,4.46,15.42,15.42,0,0,0,0,5.25,61.53,61.53,0,0,0,1.5,6.34c1.23,4.48,2.52,8.47,3.51,11.35.47,1.36.86,2.5,1.18,3.41a7.16,7.16,0,0,1,.38,1.27,6.61,6.61,0,0,1-.58-1.2c-.33-.78-.8-1.92-1.34-3.35-1.08-2.85-2.44-6.85-3.67-11.34A57,57,0,0,1,286,177a15.25,15.25,0,0,1,.08-5.39,9.8,9.8,0,0,1,1.38-3.37A3.77,3.77,0,0,1,288.32,167.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.3,205.71a5.09,5.09,0,0,1-1.9,1.29A9.57,9.57,0,0,1,209,205.41a5,5,0,0,1-1.42-1.79c.07-.06.59.65,1.66,1.51a10.09,10.09,0,0,0,10.07,1.53C220.54,206.16,221.25,205.64,221.3,205.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.37,189.2a4,4,0,0,1-.29.77c-.22.5-.56,1.22-1.05,2.12a29.39,29.39,0,0,1-5.28,6.91,23.84,23.84,0,0,1-11.28,6.13,21.11,21.11,0,0,1-7.64.33,22.42,22.42,0,0,1-7.73-2.75c-4.91-2.74-9.06-6.21-13.6-7.87a21.31,21.31,0,0,0-12.54-.69,22.2,22.2,0,0,0-7.79,3.57c-1.64,1.21-2.41,2.06-2.45,2a15.49,15.49,0,0,1,2.33-2.17,21.92,21.92,0,0,1,20.62-3.17c4.65,1.68,8.83,5.16,13.68,7.86A22.22,22.22,0,0,0,263.9,205a20.89,20.89,0,0,0,7.47-.3,23.67,23.67,0,0,0,11.12-5.93,30.12,30.12,0,0,0,5.36-6.74c.51-.88.89-1.59,1.13-2.07A5.43,5.43,0,0,1,289.37,189.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.61,176.37a5.39,5.39,0,0,1,.46,1.16,13.75,13.75,0,0,1,.58,3.33,15.53,15.53,0,0,1-3.37,10.48,39.17,39.17,0,0,1-4.46,4.22,11.87,11.87,0,0,0-3,3.81,6.44,6.44,0,0,0-.67,3.18c.06.78.23,1.2.18,1.21s-.07-.09-.15-.29a3.8,3.8,0,0,1-.23-.9,6.22,6.22,0,0,1,.53-3.35,11.81,11.81,0,0,1,3-4,43.61,43.61,0,0,0,4.37-4.19,15.77,15.77,0,0,0,3.41-10.14A24.71,24.71,0,0,0,311.61,176.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,260.68a3.91,3.91,0,0,1-1,.37,21.21,21.21,0,0,1-2.94.62,10.2,10.2,0,0,1-4.49-.26,6.65,6.65,0,0,1-2.35-1.32,20.18,20.18,0,0,1-1.92-2.1,10,10,0,0,0-2-1.86,9.8,9.8,0,0,0-2.29-1.1,10.14,10.14,0,0,0-4.29-.41,8.83,8.83,0,0,0-2.82.8,7,7,0,0,1-1,.46,3.29,3.29,0,0,1,.9-.64,8.1,8.1,0,0,1,2.87-1,9.93,9.93,0,0,1,4.48.31,9.56,9.56,0,0,1,2.43,1.14,9.71,9.71,0,0,1,2.12,1.94,20.89,20.89,0,0,0,1.86,2.05,6.48,6.48,0,0,0,2.17,1.26,10.53,10.53,0,0,0,4.3.35C252.3,261,253.82,260.59,253.84,260.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.83,258.55a1.69,1.69,0,0,1-.32.27,10,10,0,0,1-1,.66,14.7,14.7,0,0,1-4,1.69,16.93,16.93,0,0,1-6.49.38,16,16,0,0,1-7.38-3,74.29,74.29,0,0,1-5.9-5.31,18.87,18.87,0,0,0-5.24-3.6,9.93,9.93,0,0,0-4.15-.92c-1,0-1.58.17-1.59.11a1.7,1.7,0,0,1,.4-.13,5.76,5.76,0,0,1,1.18-.19,9.76,9.76,0,0,1,4.31.79,18.52,18.52,0,0,1,5.41,3.59c1.83,1.62,3.65,3.59,5.89,5.24a15.7,15.7,0,0,0,7.13,2.9,17.41,17.41,0,0,0,6.34-.25,16.82,16.82,0,0,0,4-1.51A12.86,12.86,0,0,1,299.83,258.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.83,116.06a51.12,51.12,0,1,1,66.83-70.79h0a51.11,51.11,0,0,1-66.83,70.79Zm42.62-89.14a47.68,47.68,0,1,0,21.21,20A47.67,47.67,0,0,0,427.45,26.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.11,172h0a6.37,6.37,0,0,1-8.75-2.07l-33.43-54.19a1.09,1.09,0,0,1,.35-1.5l7.13-4.4a1.1,1.1,0,0,1,1.49.33L473.06,163A6.36,6.36,0,0,1,471.11,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,113.48a51.13,51.13,0,1,1,66.83-70.8h0a51.12,51.12,0,0,1-66.83,70.8Zm42.62-89.14a47.68,47.68,0,1,0,21.21,20A47.67,47.67,0,0,0,428.68,24.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.88,104h10.53a0,0,0,0,1,0,0v67.71a5,5,0,0,1-5,5h-.61a5,5,0,0,1-5-5V104a0,0,0,0,1,0,0Z",
    transform: "translate(-6.2 258.8) rotate(-31.67)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.94,55.22a9.23,9.23,0,0,1,.28-1.58,14.93,14.93,0,0,1,.47-1.82,24.57,24.57,0,0,1,.8-2.37L372,48.1c.19-.47.44-.93.67-1.43.45-1,1.06-2,1.67-3.05a39.75,39.75,0,0,1,4.9-6.28,40.08,40.08,0,0,1,6.14-5.06,34.59,34.59,0,0,1,3-1.75c.48-.25.94-.51,1.4-.72l1.34-.57a23.2,23.2,0,0,1,2.34-.86,14.3,14.3,0,0,1,1.81-.52,11.59,11.59,0,0,1,1.57-.33,10.58,10.58,0,0,1-1.52.51,16.14,16.14,0,0,0-1.77.6,23.28,23.28,0,0,0-2.29.92l-1.31.59c-.46.21-.91.48-1.38.73-1,.49-1.92,1.13-2.95,1.77a40.54,40.54,0,0,0-6,5,41.31,41.31,0,0,0-4.87,6.17c-.61,1-1.23,2-1.69,3-.23.48-.49.93-.69,1.39l-.56,1.33c-.38.83-.61,1.63-.86,2.32a16,16,0,0,0-.54,1.79A10.24,10.24,0,0,1,369.94,55.22Z",
    style: {
      fill: "#e0e0e0"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImg);
export default __webpack_public_path__ + "static/media/search-img.bc303ebb8ab46833dc5537780f18852d.svg";
export { ForwardRef as ReactComponent };